var map = {
	"./btn1.png": "7321",
	"./btn1s.png": "646c",
	"./btn2.png": "fb31",
	"./btn2s.png": "8472",
	"./btn3.png": "e4b8",
	"./btn3s.png": "ed40",
	"./btn4.png": "5647",
	"./btn4s.png": "441f",
	"./btn5.png": "b0a9",
	"./btn5s.png": "3591",
	"./btn6.png": "c227",
	"./btn6s.png": "cecd",
	"./btn7.png": "2e64",
	"./btn7s.png": "608e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c35";